<template>
  <div class="head_container">
    <div class="main_header" ref="mainHeader">
      <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
        <el-menu-item index="'0'">
          <div class="header_logo" @click="goToPage('index')">
            <img src="../assets/images/logo.png" alt="">
          </div>
        </el-menu-item>
        <el-menu-item index="'1'"><a @click="goToPage('index')">首页</a></el-menu-item>
        <el-menu-item index="'2'"><a @click="goToPage('intelligent')">智能CRM</a></el-menu-item>
        <el-menu-item index="'6'"><a @click="goToPage('project')">经营管控</a></el-menu-item>
        <el-menu-item index="'3'"><a @click="goToPage('live')">直播平台</a></el-menu-item>
        <!--<el-menu-item index="'4'"><a @click="goToPage('index')">微客服</a></el-menu-item>-->
        <!--<el-submenu index="'2'">-->
        <!--<template slot="title">产品中心</template>-->
        <!--<el-menu-item index="'2-1'"><a @click="goToPage('intelligent')">智能CRM</a></el-menu-item>-->
        <!--<el-menu-item index="'2-2'"><a @click="goToPage('live')">直播平台</a></el-menu-item>-->
        <!--<el-menu-item index="'2-3'"><a @click="goToPage('customer')">微客服</a></el-menu-item>-->
        <!--</el-submenu>-->
        <el-menu-item index="'7'"><a @click="goToPage('wheatSchool')">博商小麦</a></el-menu-item>
        <el-menu-item index="'5'"><a @click="goToPage('contact')">联系我们</a></el-menu-item>
        <button class="rt header_btn" @click="showDialog=true">立即体验</button>
      </el-menu>
      <my-dialog :show-dialog.sync="showDialog"></my-dialog>
    </div>
  </div>
</template>
<script>
import $ from 'jquery'
import myDialog from '../components/my-dialog'

export default {
  data() {
    return {
      activeIndex: '1',
      activeIndex2: '1',
      showDialog: false
    };
  },
  methods: {
    handleSelect(key, keyPath) {

    },
    goToPage: function (path) {
      var vm = this;
      vm.$router.push(path);
    }
  },
  components: {myDialog}
}
</script>



// WEBPACK FOOTER //
// src/components/mainHeader.vue